export { default } from "./Material.page";
